/* cf-latch-image-fix.js — glass calculator "Hardware Selected" latch picture (Pete, 1 Oct 2026:
   "can we use a white latch picture for the calculator").
   getLatchImageUrl compared the chosen colour ("white"/"black") to the variant colour by exact match.
   Since the 28 Sep relink the variants are "Matte White"/"Matte Black", so nothing matched and it fell
   back to the first variant — the chrome (Mirror) latch — for every colour. The gate position was also
   compared as "glass-to-glass" against "Glass to Glass". This matches both loosely, the same way
   getHingeImageUrl already does. Display only: never touches price, SKU or cart. */
(function () {
  var tries = 0;
  function colourKey(c) {
    c = String(c || '').toLowerCase();
    return c.indexOf('white') > -1 ? 'white' : c.indexOf('black') > -1 ? 'black' : 'mirror';
  }
  function posKey(p) { return String(p || '').toLowerCase().replace(/[-_]+/g, ' ').replace(/\s+/g, ' ').trim(); }
  // Glass only (Pete, 1 Oct 2026): aluminium gate hinges and latches are always black and those
  // calculators keep their own latch pictures. #spigot-shape / #hw-sel-latch are in the glass page HTML only.
  function isGlassPage() { return !!(document.getElementById('spigot-shape') || document.getElementById('hw-sel-latch')); }
  function install() {
    if (!isGlassPage()) return true;
    var gc = window.glassCalculator;
    if (!gc || typeof gc.getLatchImageUrl !== 'function') return false;
    var P = Object.getPrototypeOf(gc);
    if (P.__cfLatchImgPatched) return true;
    var orig = P.getLatchImageUrl;
    P.getLatchImageUrl = function (sectionNum) {
      try {
        var n = sectionNum || 1;
        var s = this.state && this.state.sections ? this.state.sections[n] : null;
        var lp = this.shopifyData && this.shopifyData.products && this.shopifyData.products.gateLatch;
        if (lp && lp.variants) {
          var fin = this.resolveSectionFinish(s) || {};
          var c = colourKey(fin.hingeLatchColour || (s && s.latchColor) || 'black');
          var t = posKey((s && s.latchType) || 'glass-to-glass');
          var av = lp.variants.filter(function (v) { return v.available && v.image; });
          var m = av.find(function (v) { return posKey(v.position) === t && colourKey(v.color) === c; }) ||
                  av.find(function (v) { return posKey(v.position) === 'glass to glass' && colourKey(v.color) === c; }) ||
                  av.find(function (v) { return colourKey(v.color) === c; });
          if (m) return m.image;
        }
      } catch (e) { try { console.warn('[cf-latch-image-fix]', e); } catch (_) {} }
      return orig.apply(this, arguments);
    };
    // The Add Sections "Hardware Selected" box (#hw-sel-latch) uses its own lookup with the same exact match.
    if (typeof P._glassToGlassLatchImg === 'function') {
      var origG2G = P._glassToGlassLatchImg;
      P._glassToGlassLatchImg = function (colour) {
        try {
          var lp = this.shopifyData && this.shopifyData.products && this.shopifyData.products.gateLatch;
          if (lp && lp.variants) {
            var c = colourKey(colour);
            var av = lp.variants.filter(function (v) { return v.available && v.image; });
            var m = av.find(function (v) { return posKey(v.position) === 'glass to glass' && colourKey(v.color) === c; }) ||
                    av.find(function (v) { return colourKey(v.color) === c; });
            if (m) return m.image;
          }
        } catch (e) { try { console.warn('[cf-latch-image-fix]', e); } catch (_) {} }
        return origG2G.apply(this, arguments);
      };
    }
    // Wall-mounted gates (Pete, 2 Oct 2026: picked from the store photos, "s2 and s4 are around the wrong way.
    // the rest are ok"). The calculator picks hinge pictures by colour only, so a wall-to-glass gate showed the
    // glass-to-glass hinge. When the section's gate is wall-to-glass, show the wall-to-glass hinge instead.
    var F = 'https://cdn.shopify.com/s/files/1/0570/6530/8254/files/';
    var WALL_HINGE = {
      spring: {
        black: F + 'WalltoGlassBlack_1080x1080_6855cce6-e6cc-4dbb-a870-11501f4b9012.png?v=1759137937&width=800',
        white: F + 'Wall_to_Post_White_Resized_1080x1080_00d5b845-3e42-415b-b946-9a2ae2d77d39.png?v=1759138742&width=800',
        mirror: F + 'WalltoPostMirrorHinges_1080x1080_4f1df9f2-3259-485a-a640-61b8d5752437.png?v=1759137938&width=800'
      },
      'soft-close': {
        black: F + 'Soft_Close_Wall_to_Glass_Hinge_Black_ea8c8b4b-41a4-4647-876d-e919f11bc19f.png?v=1740230259&width=800',
        white: F + 'Spring_Wall_to_Glass_Hinges_White_2561617f-233b-480c-b50c-1fc34c5afde8.png?v=1740230655&width=800',
        mirror: F + 'Soft_Close_Wall_to_Glass_Hinge_Stainless_Steel_9674b0a2-ce22-4d12-9f5e-33492d8764ec.png?v=1740230519&width=800'
      }
    };
    function wallHingeFor(calc, n, hingeType, colour) {
      var s = calc.state && calc.state.sections ? calc.state.sections[n || 1] : null;
      if (!s || !s.hasGate || s.gateHingeType !== 'wall-to-glass') return null;
      var set = WALL_HINGE[hingeType === 'soft-close' ? 'soft-close' : 'spring'];
      return set[colourKey(colour)] || null;
    }
    var origHinge = P.getHingeImageUrl;
    P.getHingeImageUrl = function (sectionNum) {
      try {
        var n = sectionNum || 1;
        var s = this.state && this.state.sections ? this.state.sections[n] : null;
        var fin = this.resolveSectionFinish(s) || {};
        var u = wallHingeFor(this, n, fin.hingeType || 'spring', fin.hingeLatchColour || (s && s.hingeColor) || 'black');
        if (u) return u;
      } catch (e) { try { console.warn('[cf-latch-image-fix]', e); } catch (_) {} }
      return origHinge.apply(this, arguments);
    };
    if (typeof P._hingeImgFor === 'function') {
      var origHingeFor = P._hingeImgFor;
      P._hingeImgFor = function (hingeType, colour, sectionNum) {
        try {
          var u = wallHingeFor(this, sectionNum || this.getCurrentSectionNumber(), hingeType, colour);
          if (u) return u;
        } catch (e) { try { console.warn('[cf-latch-image-fix]', e); } catch (_) {} }
        return origHingeFor.apply(this, arguments);
      };
    }
    P.__cfLatchImgPatched = true;
    try { gc.updateHardwarePreviews(); } catch (e) {}
    try { gc._updateHingeSelectedPreview(); } catch (e) {}
    try { console.log('[cf-latch-image-fix] installed'); } catch (e) {}
    return true;
  }
  (function tryInstall() {
    if (install() || ++tries > 120) return;
    setTimeout(tryInstall, 250);
  })();
})();
